import { Tags } from '~/types/tags';

const tag: Tags = {
  accomplished: {
    id: 'accomplished',
    text: 'Realizada',
    type: 'positive',
  },
  completed: {
    id: 'completed',
    text: 'Aprovado',
    type: 'positive',
  },
  in_progress: {
    id: 'in_progress',
    text: 'Em andamento',
    type: 'informative',
  },
  reproved: {
    id: 'reproved',
    text: 'Reprovado',
    type: 'negative',
  },
  sent_message: {
    id: 'sent_message',
    text: 'Enviado',
    type: 'informative',
  },
  signed: {
    id: 'signed',
    text: 'Assinado',
    type: 'positive',
  },
  under_analysis: {
    id: 'under_analysis',
    text: 'Em análise',
    type: 'informative',
  },
  waiting: {
    id: 'waiting',
    text: 'Aguardando',
    type: 'neutral',
  },
  waiting_biometry: {
    id: 'waiting',
    text: 'Aguardando biometria',
    type: 'neutral',
  },
};

export default tag;
